class DanhMuc {
  private id
  private name
  private id_name

  constructor(options) {
    this.id = options.danh_muc_id
    this.name = options.ten
    this.id_name = options.ma_viet_tat
  }
}

export default DanhMuc
